import { FDSnackbar } from '@facet-wealth/design';
import React, { useState } from 'react';
import { inputDefaultProps, inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import PropTypes from 'prop-types';
import { useDataAttrs } from 'Helpers/Testing';

export const Snackbar = (props) => {
  const {
    value,
    ...rest
  } = props;

  const [open, setOpen] = useState(!!value);

  return (
    <FDSnackbar
      {...useDataAttrs(rest)}
      message={value}
      open={open}
      onClose={() => setOpen(false)}
    />
  );
};

Snackbar.defaultProps = {
  alignSelf: inputDefaultProps.alignSelf,
  disabled: inputDefaultProps.disabled,
  error: inputDefaultProps.error,
  flexGrow: inputDefaultProps.flexGrow,
  flexShrink: inputDefaultProps.flexShrink,
  fullWidth: inputDefaultProps.fullWidth,
  helperTextValue: inputDefaultProps.helperTextValue,
  label: inputDefaultProps.label,
  onBlur: inputDefaultProps.onBlur,
  onFocus: inputDefaultProps.onFocus,
  readonly: inputDefaultProps.readonly,
  value: undefined,
};

Snackbar.propTypes = {
  alignSelf: inputPropTypes.alignSelf,
  disabled: inputPropTypes.disabled,
  flexGrow: inputPropTypes.flexGrow,
  flexShrink: inputPropTypes.flexShrink,
  label: PropTypes.node,
  size: inputPropTypes.size.isRequired,
  helperTextValue: inputPropTypes.helperTextValue,
  error: inputPropTypes.error,
  value: PropTypes.bool,
  onBlur: inputPropTypes.onBlur,
  onChange: inputPropTypes.onChange.isRequired,
  onFocus: inputPropTypes.onFocus,
  fullWidth: inputPropTypes.fullWidth,
  readonly: inputPropTypes.readonly,
};
